import styled from 'styled-components'

import Button from '.'

const ButtonSmall = styled(Button)`
  padding-top: unset;
  padding-bottom: unset;
  height: 48px;
`

export default ButtonSmall
